import React, { useState } from "react";
import "./SignupPage.css";
import AuthFooter from "../Shared/AuthFooter/AuthFooter";
import SignupStepper from "./Component/SignupStepper";
import Step1Verification from "./Component/Step1Verification";
import Step2InfoForm from "./Component/Step2InfoForm";
import Step3Complete from "./Component/Step3Complete";

const SignupPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);

  const handleNextStep = () => {
    setCurrentStep((prev) => (prev < 3 ? prev + 1 : 3));
  };

  const handleBackStep = () => {
    setCurrentStep((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const handleRegistrationSuccess = (email, password) => {
    setEmail(email);
    setPassword(password);
  }

  const renderStepComponent = () => {
    switch (currentStep) {
      case 1:
        return <Step1Verification onNextStep={handleNextStep} />;
      case 2:
        return (
          <Step2InfoForm
            onNextStep={handleNextStep}
            onBackStep={handleBackStep}
            onRegistrationSuccess={handleRegistrationSuccess}
          />
        );
      case 3:
        return <Step3Complete email={email} password={password} />;
      default:
        return <Step1Verification onNextStep={handleNextStep} />;
    }
  };

  return (
    <div className="signup-page-container">
      <div className="signup-form-wrapper">
        <h1 className="signup-title">회원가입</h1>
        <SignupStepper activeStep={currentStep} />
        {renderStepComponent()}
      </div>
      <AuthFooter />
    </div>
  );
};

export default SignupPage;
